/* tslint:disable */
/* eslint-disable */
/**
 * COTATO 프로젝트 API 명세서
 * api 명세서
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const CotatoProfileLinkResponseUrlTypeEnum = {
    Github: 'GITHUB',
    Behance: 'BEHANCE',
    Blog: 'BLOG',
    Other: 'OTHER'
};
/**
 * Check if a given object implements the CotatoProfileLinkResponse interface.
 */
export function instanceOfCotatoProfileLinkResponse(value) {
    if (!('linkId' in value) || value['linkId'] === undefined)
        return false;
    if (!('urlType' in value) || value['urlType'] === undefined)
        return false;
    if (!('url' in value) || value['url'] === undefined)
        return false;
    return true;
}
export function CotatoProfileLinkResponseFromJSON(json) {
    return CotatoProfileLinkResponseFromJSONTyped(json, false);
}
export function CotatoProfileLinkResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'linkId': json['linkId'],
        'urlType': json['urlType'],
        'url': json['url'],
    };
}
export function CotatoProfileLinkResponseToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'linkId': value['linkId'],
        'urlType': value['urlType'],
        'url': value['url'],
    };
}
